const ADMIN_LOGIN = "ADMIN_LOGIN"

export const setAdminLogin = (payload) => {
    return {
        type: ADMIN_LOGIN,
        payload
    };
};